module.exports = __webpack_public_path__ + "1e4f1c1c7d03b9a4a7f4b9998bb40c43.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/microphone.png
 ** module id = 1572
 ** module chunks = 0
 **/